import React from 'react';
import { T } from '../../../helpers/i18n';
import { BlockSeparator } from './BlockSeparator';
export var BlockBookingFee = function (_a) {
    var item = _a.item;
    if (item.feeLines) {
        console.log('item: ', item.feeLines);
        var totalFee_1 = 0;
        item.feeLines.forEach(function (feeLine) { return totalFee_1 += feeLine.total; });
        var subtotal_1 = item.total - totalFee_1;
        return (React.createElement(React.Fragment, null, item.feeLines.map(function (feeLine) {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { key: 'subtotal_' + feeLine.id, style: { margin: '0', padding: 0, textAlign: 'end', } }, "".concat(T('subtotal'), " ").concat(subtotal_1.toFixed(2), " ").concat(item.money)),
                React.createElement("p", { key: 'feeline' + feeLine.id, style: { margin: '0', padding: 0, textAlign: 'end', } }, "".concat(T(feeLine.name), " ").concat(feeLine.total.toFixed(2), " ").concat(item.money)),
                React.createElement(BlockSeparator, { noMarginTop: true })));
        })));
    }
    return null;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockBookingFee.tsx
// module id = 1158
// module chunks = 0